import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { ADMIN_ANEEL_TARIFFS_ENDPOINTS, AdminAneelTariffs } from "@/service/api/admin-aneel-tariffs";
import { ListAneelTariffImportHistoryDto } from "@/service/dto/admin-aneel-tariffs";
import useToastOnError from "@/modules/common/hooks/useToastOnError";

const useAneelTariffImportHistory = (params: ListAneelTariffImportHistoryDto) => {
  const query = useQuery({
    queryKey: [ADMIN_ANEEL_TARIFFS_ENDPOINTS.GET_IMPORT_HISTORY, params],
    queryFn: () => AdminAneelTariffs.getImportHistory(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useToastOnError(query.isError, query.error, "Erro ao carregar histórico de importações.");

  return query;
};

export default useAneelTariffImportHistory;
